import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _ from 'lodash';
import moment from 'moment';
let _queryParams = null;
let _lastSearch = '';
let _hashParam = null;
let _lastHash = ''; // 模板配置工具

function isTemplateToolMode() {
  return window.__preview === true;
} // 判断是否为非空数组


export const isNotEmptyArray = arr => Array.isArray(arr) && arr.length > 0;

const isEmptyValue = val => [null, undefined, ''].includes(val); // 判断是否有空值


export const hasEmptyValue = data => {
  const judgeObj = obj => {
    const keys = Object.keys(obj);
    if (!keys.length) return true;
    return keys.some(key => {
      const value = obj[key];

      if (_.isArray(value)) {
        return value.some(judgeObj);
      }

      if (_.isPlainObject(value)) {
        return judgeObj(value);
      }

      return isEmptyValue(value);
    });
  };

  if (_.isArray(data)) {
    return data.some(judgeObj);
  }

  if (_.isPlainObject(data)) {
    return judgeObj(data);
  }

  return isEmptyValue(data);
};

function hasValue(val) {
  return val || val === 0 || val === false;
}

function parseParam(paramStr, delimiter) {
  const obj = {};

  if (paramStr) {
    const arr = paramStr.split(delimiter || '&');
    arr.length && arr.forEach(item => {
      const tempArr = item.split('=');
      obj[tempArr[0]] = decodeURIComponent(tempArr[1] || '');
    });
  }

  return obj;
}

function toParam(data, encode) {
  const ret = '';

  if (_.isPlainObject(data)) {
    return Object.keys(data).map(item => {
      return `${item}=${encode ? encodeURIComponent(data[item] || '') : data[item]}`;
    }).join('&');
  }

  return ret;
} // 遍历树


export const traverseTree = (tree, action, nodeName = 'children') => {
  let stack = [];

  if (tree instanceof Array) {
    stack = tree;
  }

  while (stack.length) {
    const node = stack.shift();
    action(node);

    if (node.children) {
      stack = node[nodeName].concat(stack); // 调换concat顺序决定 深度优先 或 广度优先
    }
  }
};
/**
 * 接收类似configList结构的数据数组, 和一个name列表
 * 根据name列表逐层找到与最后一个name相等的组件
 * 如:  找保费试算模块下的保险计划模块   insurancePlanTrialCalculation > insurancePlanTrialCollect
 * findComponentByName(packageList, 'insurancePlanTrialCalculation', 'insurancePlanTrialCollect')
 * @param tree [{children: tree}, {moduleList: tree}]
 * @param nameList 任意个字符串类型的参数 作为name列表
 * @returns
 */

const findComponentByName = (tree, ...nameList) => {
  let stack = [];

  if (tree instanceof Array) {
    stack = tree;
  }

  const targetName = nameList.shift();
  let result = [];

  while (stack.length) {
    const node = stack.shift();
    let nextLayerStack = [];
    const nextNode = node.children || node.moduleList;

    if (node.component === targetName) {
      if (nameList.length === 0) {
        result.push(node);
      } else {
        result = result.concat(findComponentByName(nextNode, ...nameList));
      } // 如果当前层找到了目标  清空下一层列表  --不清空就是遍历所有节点


      nextLayerStack = [];
    } else if (nextNode) {
      nextLayerStack = nextLayerStack.concat(nextNode);
    } // 当前层循环完了 开始循环下一层


    if (!stack.length) {
      stack = stack.concat(nextLayerStack);
    }
  }

  return result;
}; // ios键盘失焦后滚动


const fixInputBlur = () => {
  const u = navigator.userAgent;
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

  if (isIOS) {
    setTimeout(() => {
      const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
      window.scrollTo(0, Math.max(scrollHeight - 1, 0));
    }, 200);
  }
}; // 当前聚焦输入框滚动至可视区域


const fixInputFocus = () => {
  const u = navigator.userAgent;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;

  if (isAndroid) {
    setTimeout(() => {
      document.activeElement.scrollIntoViewIfNeeded();
    }, 500);
  }
}; // 按下表合并两个对象数组  第二个覆盖第一个


export const mergeObjectInArray = (arr1, arr2) => {
  const length = arr1.length > arr2.length ? arr1.length : arr2.length;
  const result = [];

  for (let i = 0; i < length; i++) {
    result.push(_objectSpread(_objectSpread({}, arr1[i]), arr2[i]));
  }

  return result;
}; // 在一个树形节点中 获的指定节点的路径

function getValuePath(value, list, valueMember = 'value', childrenMember = 'children') {
  const path = [];

  if (list && list.length && hasValue(value)) {
    for (let i = 0, len = list.length; i < len; i++) {
      const item = list[i];
      path.push(item);

      if (item[valueMember] === value) {
        return path;
      }

      const childPath = getValuePath(value, item[childrenMember], valueMember, childrenMember);

      if (childPath.length) {
        return path.concat(childPath);
      }

      path.pop();
    }
  }

  return path;
}

function getStringValue(value) {
  if (value instanceof Array) {
    return value.join(',');
  }

  return hasValue(value) ? String(value) : '';
}

function getValue(value) {
  return hasValue(value) ? value : '';
} // 把价格数字 转换成带有W的方式表示 eg 10000 ==》 1w


function toWan(num) {
  if (num > 10000) {
    return `${num / 10000}万`;
  }

  if (num === null || num === undefined || Number.isNaN(num)) {
    return '';
  }

  return num;
}

function getQueryParam() {
  if (!_queryParams || _lastSearch !== window.location.search) {
    _lastSearch = window.location.search;
    _queryParams = parseParam(_lastSearch.substr(1));
  }

  return _queryParams;
}

function getHashParam(hash) {
  if (!_hashParam || _lastHash !== window.location.hash) {
    _lastHash = window.location.hash;
    _hashParam = parseParam(_lastHash.substr(1));
  }

  if (typeof hash === 'string') return _hashParam[hash];
  return _hashParam;
} // 中台配置的时候中间iframe预览, 配置数据从postmesage拿
// 或者模板配置工具使用
// 有点选框， 无法交互


function isPreviewMode() {
  return getQueryParam().mode === 'preview' || isTemplateToolMode();
} // 手机扫二维码预览，配置数据从接口拿


function isSimulateMode() {
  return getQueryParam().mode === 'simulate';
} // 纯预览模板，配置数据从postmesage拿
// 无 点选框
// 配置流程 + 模板工具使用


function isTemplateMode() {
  return getQueryParam().mode === 'template';
}

function isNormalMode() {
  return !getQueryParam().mode && !isTemplateToolMode();
}

function updateFormKey(children, index) {
  // insurant.name => insurant[0].name
  // insurant[0].name => insurant[0][0].name
  const reg = /\.([a-z_]+)$/i;
  return children.map(item => {
    return _objectSpread(_objectSpread({}, item), {}, {
      formKey: item.formKey && item.formKey.replace(reg, `[${index}].$1`)
    });
  });
}

function rerangeFormKey(children, index) {
  // insurant.name => insurant[1].name
  // insurant[0].name => insurant[1].name
  const reg = /(\[\d+\])?\.([a-z_]+)$/i;
  children.forEach(item => {
    if (item.formKey) {
      item.formKey = item.formKey.replace(reg, `[${index}].$2`);
    }
  });
}

function getScrollTop() {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

function parseDate(val) {
  if (!val) return '';

  if (typeof val === 'string') {
    val = val.replace(/-/g, '/');
  }

  const date = new Date(val);

  if (String(date) === 'Invalid Date') {
    return '';
  }

  return date;
}

function addDay(date, num) {
  date = parseDate(date);

  if (typeof num === 'string') {
    num = +num;
  }

  return new Date(date.setDate(date.getDate() + num));
}

function addMonth(date, num) {
  date = parseDate(date);

  if (typeof num === 'string') {
    num = +num;
  }

  return new Date(date.setMonth(date.getMonth() + num));
}

function addYear(date, num) {
  date = parseDate(date);

  if (typeof num === 'string') {
    num = +num;
  }

  return new Date(date.setFullYear(date.getFullYear() + num));
}

function formatDate(date, fmt) {
  date = parseDate(date);

  if (!date) {
    return '';
  }

  if (!fmt) {
    fmt = 'yyyy-MM-dd';
  }

  const o = {
    'M+': date.getMonth() + 1,
    // 月份
    'd+': date.getDate(),
    // 日
    'h+': date.getHours(),
    // 小时
    'm+': date.getMinutes(),
    // 分
    's+': date.getSeconds(),
    // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3),
    // 季度
    S: date.getMilliseconds() // 毫秒

  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
  }

  Object.keys(o).forEach(k => {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length));
    }
  });
  return moment(date).format(fmt);
}

function toAge(birthday) {
  const anchor = parseDate(birthday);

  if (anchor) {
    const now = new Date();
    let age = now.getFullYear() - anchor.getFullYear();

    if (now.getMonth() > anchor.getMonth()) {
      age += 1;
    } else if (now.getMonth() === anchor.getMonth()) {
      if (now.getDate() > anchor.getDate()) {
        age += 1;
      }
    }

    return age - 1;
  }

  return '';
}

function getBirthday(idCard) {
  let birthday = '';

  if (idCard.length === 15) {
    birthday = `19${idCard.substr(6, 6)}`;
  } else if (idCard.length === 18) {
    birthday = idCard.substr(6, 8);
  }

  birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-');
  return birthday;
}

function getSex(idCard) {
  let sex = '';

  if (parseInt(idCard.substr(16, 1), 10) % 2 === 1) {
    return 'male';
  }

  sex = 'female';
  return sex;
}

function toZhGender(gender) {
  let zhGender = '';

  if (gender.toLowerCase() === 'male') {
    zhGender = '男';
  } else if (gender.toLowerCase() === 'female') {
    zhGender = '女';
  }

  return zhGender;
}

const isPC = () => {
  const userAgentInfo = navigator.userAgent;
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  let flag = true;

  for (let i = 0; i < Agents.length; i++) {
    if (userAgentInfo.indexOf(Agents[i]) != -1) {
      flag = false;
      break;
    }
  }

  return flag;
};

function isInTemplateTool() {
  return getQueryParam().template === 'true';
}

const getCurrentPageIndex = () => {
  var _getHashParam;

  return ((_getHashParam = getHashParam()) === null || _getHashParam === void 0 ? void 0 : _getHashParam.page) || 1;
};

export { // form
updateFormKey, rerangeFormKey, // param
toParam, parseParam, getQueryParam, getHashParam, // mode
isPreviewMode, isSimulateMode, isTemplateMode, isTemplateToolMode, isNormalMode, // date
parseDate, formatDate, addDay, addMonth, addYear, // others
getScrollTop, toWan, hasValue, getValue, getStringValue, getValuePath, // 信息提取
toAge, getBirthday, getSex, fixInputBlur, fixInputFocus, // 性别男女
toZhGender, isPC, isInTemplateTool, getCurrentPageIndex };